import { render, staticRenderFns } from "./AgingDetails.vue?vue&type=template&id=47b019b8&scoped=true&"
import script from "./AgingDetails.vue?vue&type=script&lang=js&"
export * from "./AgingDetails.vue?vue&type=script&lang=js&"
import style0 from "./AgingDetails.vue?vue&type=style&index=0&id=47b019b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b019b8",
  null
  
)

export default component.exports